export function normalizeAngle(a) {
  return (a + Math.PI * 2) % (Math.PI * 2);
}
